import { render, staticRenderFns } from "./AgronomicManagement.vue?vue&type=template&id=4371ef54&scoped=true&"
import script from "./AgronomicManagement.vue?vue&type=script&lang=js&"
export * from "./AgronomicManagement.vue?vue&type=script&lang=js&"
import style0 from "./AgronomicManagement.vue?vue&type=style&index=0&id=4371ef54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4371ef54",
  null
  
)

export default component.exports